import { render, staticRenderFns } from "./Contabilidad.vue?vue&type=template&id=7660e6aa"
import script from "./Contabilidad.vue?vue&type=script&lang=js"
export * from "./Contabilidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports